const NAVBAR_Z_INDEX = 55;

export const getDialogZIndex = (numberOfContacts?: number) => {
	return (numberOfContacts ?? 1) + NAVBAR_Z_INDEX;
};
